import { render, staticRenderFns } from "./login2.vue?vue&type=template&id=6f443a6e&scoped=true&"
import script from "./login2.vue?vue&type=script&lang=js&"
export * from "./login2.vue?vue&type=script&lang=js&"
import style0 from "./login2.vue?vue&type=style&index=0&id=6f443a6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f443a6e",
  null
  
)

export default component.exports